export default "/images/vendor/flag-icon-css/flags/1x1/eg.svg?fd860b79f4945f3a533c74d6820a0c44";